import { useEffect, useState } from 'react'

export function useDarkMode() {
    const [isDark, setIsDark] = useState(() => {
        // Check local storage first
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem('theme')
            if (saved) {
                return saved === 'dark'
            }
            // Fallback to system preference
            return window.matchMedia('(prefers-color-scheme: dark)').matches
        }
        return false
    })

    useEffect(() => {
        const root = window.document.documentElement
        if (isDark) {
            root.classList.add('dark')
            localStorage.setItem('theme', 'dark')
        } else {
            root.classList.remove('dark')
            localStorage.setItem('theme', 'light')
        }
    }, [isDark])

    return { isDark, toggle: () => setIsDark(!isDark) }
}
